var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"landing-topbar"},[_c('ul',{staticClass:"landing-topbar__items"},[_c('li',[_c('language-switcher',{attrs:{"locale":_vm.locale,"langs":_vm.langs,"light":"","width":"74"},on:{"handle-locale":_vm.handleLocale}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }